import {DefaultContext} from '@buncha/utils/types';
import React from 'react';
import {ScanBarcodesState} from '../types/scanBarcode';

export const initialState: ScanBarcodesState = {
  barcodeCount: undefined,
};

const defaultVal: DefaultContext<ScanBarcodesState> = {
  state: initialState,
  dispatch: null,
};

export const ScanBarcodesContext = React.createContext(defaultVal);
